/* ================================================================
   LIFULL — RSI Checkout Premium Enhancement
   Overrides inline !important styles, adds UI enhancements,
   duplicates pay-advance button above offers.
   ================================================================ */
(function () {
  'use strict';

  var BADGES = [
    { text: '✓ MÁS VENDIDO', cls: 'lco-offer-badge--popular' },
    { text: '★ MEJOR OFERTA', cls: 'lco-offer-badge--best'    },
    { text: '💰 MÁX. AHORRO', cls: 'lco-offer-badge--value'   },
  ];

  var TRUST = ['🔒 Pago Seguro', '🚚 Envío Rápido', '⭐ +10.000 clientes'];

  /* setProperty with !important — overrides inline !important */
  function sp(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  /* ── 1. Header title ── */
  function styleHeader(form) {
    var title = form.querySelector('._rsi-modal-header-title');
    if (!title) return;
    sp(title, 'color', '#ffffff');
    sp(title, 'font-size', '0.76rem');
    sp(title, 'font-weight', '800');
    sp(title, 'letter-spacing', '0.09em');
    sp(title, 'text-transform', 'uppercase');
  }

  /* ── 2. Step custom-text blocks ── */
  function styleStepTexts(form) {
    form.querySelectorAll('._rsi-build-block-custom-text').forEach(function (block) {
      var inner = block.querySelector('._rsi-custom-text-field');
      if (!inner) return;
      var txt = inner.textContent || '';

      if (txt.indexOf('2️⃣') !== -1 || txt.indexOf('Escribe tus datos') !== -1) {
        block.style.display = 'none';
        return;
      }
      if (txt.indexOf('3️⃣') !== -1 || txt.indexOf('Confirma tu compra') !== -1) {
        block.style.display = 'none';
        return;
      }
      if (txt.indexOf('municipio') !== -1 || txt.indexOf('NO se despliega') !== -1) {
        block.style.padding = '0';
        block.style.margin = '0';
        sp(inner, 'color', '#92400e');
        sp(inner, 'font-size', '0.72rem');
        sp(inner, 'font-weight', '600');
        sp(inner, 'background', '#fffbeb');
        sp(inner, 'text-align', 'left');
        sp(inner, 'padding', '0.42rem 1.1rem');
        sp(inner, 'margin', '0');
        inner.className = (inner.className || '') + ' lco-warning-text';
      }
    });
  }

  /* ── 3. Offer card badges ── */
  function addBadges(form) {
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card, i) {
      if (!BADGES[i]) return;
      if (card.querySelector('.lco-offer-badge')) {
        card.classList.add('lco-has-offer-badge');
        return;
      }
      var badge = document.createElement('div');
      badge.className = 'lco-offer-badge ' + BADGES[i].cls;
      badge.textContent = BADGES[i].text;
      card.appendChild(badge);
      card.classList.add('lco-has-offer-badge');
    });
  }

  /* ── 4. Offer prices — make green (safety override) ── */
  function styleOfferPrices(form) {
    form.querySelectorAll('._rsi-quantity-offers-new-price').forEach(function (el) {
      sp(el, 'color', '#0E5F4A');
    });
  }

  /* ── 4b. Offer cards — mobile responsive safety override ── */
  function styleOfferCardsMobile(form) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 480px)').matches) return;

    var isTiny = window.matchMedia('(max-width: 360px)').matches;
    var imageSize = isTiny ? '36px' : '48px';

    form.querySelectorAll('._rsi-quantity-offers').forEach(function (wrap) {
      sp(wrap, 'padding-inline', isTiny ? '0.6rem' : '0.75rem');
    });

    form.querySelectorAll('._rsi-quantity-offers-offer').forEach(function (offer) {
      sp(offer, 'display', 'grid');
      sp(offer, 'grid-template-columns', imageSize + ' minmax(0, 1fr)');
      sp(offer, 'grid-template-areas', '"image info" ". badge" ". prices"');
      sp(offer, 'column-gap', isTiny ? '1rem' : '0.7rem');
      sp(offer, 'row-gap', '0.4rem');
      sp(offer, 'align-items', 'center');
      sp(offer, 'padding', isTiny ? '0.72rem 0.8rem' : '0.78rem 0.85rem');

      var prices = offer.querySelector('._rsi-quantity-offers-prices');
      var plaques = Array.prototype.slice.call(offer.querySelectorAll('._rsi-quantity-offers-plaque, [class*="plaque"]'));
      var plaque = plaques.find(function (el) {
        return /ahorra/i.test(el.textContent || '');
      });
      if (plaque && plaque.parentNode !== offer) {
        offer.insertBefore(plaque, prices || null);
      }
    });

    form.querySelectorAll('._rsi-quantity-offers-offer ._rsi-modal-line-item-image-container').forEach(function (img) {
      sp(img, 'grid-area', 'image');
      sp(img, 'width', imageSize);
      sp(img, 'height', imageSize);
      sp(img, 'justify-self', 'start');
    });

    form.querySelectorAll('._rsi-quantity-offers-info').forEach(function (info) {
      sp(info, 'grid-area', 'info');
      sp(info, 'width', '100%');
      sp(info, 'min-width', '0');
      sp(info, 'flex', 'initial');
    });

    form.querySelectorAll('._rsi-quantity-offers-title').forEach(function (title) {
      sp(title, 'font-size', isTiny ? '0.76rem' : '0.82rem');
      sp(title, 'line-height', isTiny ? '1.2' : '1.22');
      sp(title, 'margin-bottom', '0.32rem');
      sp(title, 'white-space', 'normal');
      sp(title, 'word-break', 'normal');
      sp(title, 'overflow-wrap', 'normal');
      sp(title, 'hyphens', 'none');
    });

    form.querySelectorAll('._rsi-quantity-offers-plaque, ._rsi-quantity-offers-offer [class*="plaque"]').forEach(function (plaque) {
      if (!/ahorra/i.test(plaque.textContent || '')) return;
      sp(plaque, 'display', 'inline-flex');
      sp(plaque, 'grid-area', 'badge');
      sp(plaque, 'width', 'fit-content');
      sp(plaque, 'max-width', '100%');
      sp(plaque, 'white-space', 'nowrap');
      sp(plaque, 'align-items', 'center');
      sp(plaque, 'justify-self', 'start');
      sp(plaque, 'position', 'static');
      sp(plaque, 'transform', 'none');
      sp(plaque, 'margin-left', '0');
      sp(plaque, 'left', 'auto');
      sp(plaque, 'right', 'auto');
      sp(plaque, 'top', 'auto');
      sp(plaque, 'bottom', 'auto');
      if (isTiny) {
        sp(plaque, 'font-size', '0.54rem');
        sp(plaque, 'padding-inline', '0.4rem');
      }
    });

    form.querySelectorAll('._rsi-quantity-offers-prices').forEach(function (prices) {
      sp(prices, 'grid-area', 'prices');
      sp(prices, 'align-items', 'flex-start');
      sp(prices, 'text-align', 'left');
      sp(prices, 'min-width', '0');
      sp(prices, 'width', '100%');
      sp(prices, 'flex-shrink', '1');
    });

    form.querySelectorAll('._rsi-quantity-offers-new-price, ._rsi-quantity-offers-old-price').forEach(function (price) {
      sp(price, 'white-space', 'nowrap');
      sp(price, 'word-break', 'normal');
    });
  }

  function setupOfferCardsMobileObserver(form) {
    if (form.dataset.lcoMobileOfferObserver === 'true') return;
    form.dataset.lcoMobileOfferObserver = 'true';

    var raf = null;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        styleOfferCardsMobile(form);
        addBadges(form);
        addStockIndicators(form);
      });
    }

    new MutationObserver(schedule).observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('resize', schedule, { passive: true });

    var attempts = 0;
    var retry = setInterval(function () {
      styleOfferCardsMobile(form);
      addBadges(form);
      addStockIndicators(form);
      attempts += 1;
      if (attempts >= 16) clearInterval(retry);
    }, 250);
  }

  /* ── 5. Main submit button ── */
  function styleSubmitBtn(form) {
    var btn = form.querySelector('._rsi-modal-submit-button');
    if (!btn) return;
    sp(btn, 'background', 'linear-gradient(135deg, #d49000 0%, #FBDB12 45%, #f5c842 100%)');
    sp(btn, 'color', '#1a0800');
    sp(btn, 'border-radius', '14px');
    sp(btn, 'box-shadow', '0 4px 28px rgba(251,219,18,0.58), 0 2px 8px rgba(0,0,0,0.22)');
    sp(btn, 'font-size', '0.94rem');
    sp(btn, 'animation', 'lco-glow-yellow 2.5s ease-in-out infinite');

    /* Rewrite label text, preserving the dynamic price span */
    var outerSpan = btn.querySelector('span');
    if (outerSpan) {
      var priceEl = outerSpan.querySelector('.rsi-cod-form-submit-total-value');
      if (priceEl) {
        outerSpan.textContent = '';
        outerSpan.appendChild(document.createTextNode('🚚 CONFIRMAR PEDIDO · PAGO CONTRA ENTREGA — '));
        outerSpan.appendChild(priceEl);
      }
    }
  }

  /* ── 6. Pay-advance button (original, bottom position) ── */
  function stylePayAdvanceBtn(form) {
    var btn = form.querySelector('._rsi-buy-now-custom-additionals-button');
    if (!btn) return;
    sp(btn, 'background', 'linear-gradient(135deg, #4c1d95 0%, #6d28d9 50%, #7c3aed 100%)');
    sp(btn, 'color', '#ffffff');
    sp(btn, 'border', '0px solid transparent');
    sp(btn, 'border-radius', '12px');
    sp(btn, 'box-shadow', '0 4px 18px rgba(109,40,217,0.42)');
    sp(btn, 'font-size', '0.85rem');
    sp(btn, 'font-weight', '800');
    sp(btn, 'animation', 'lco-glow-purple 2.5s ease-in-out infinite');

    var span = btn.querySelector('span');
    if (span) span.textContent = '🔥 AHORRA 5% ADICIONAL — PAGO ANTICIPADO';
  }

  /* ── 7. Duplicate pay-advance button ABOVE offers ── */
  function insertPayAdvanceTop(form) {
    if (form.querySelector('.lco-early-pay-top-wrap')) return;

    var originalBtn = form.querySelector('._rsi-buy-now-custom-additionals-button');

    var wrap = document.createElement('div');
    wrap.className = 'lco-early-pay-top-wrap';

    var btn = document.createElement('a');
    btn.className = 'lco-early-pay-top-btn';
    btn.href = (originalBtn && originalBtn.href) ? originalBtn.href : '#';
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.textContent = '🔥 AHORRA 5% ADICIONAL — PAGAR ANTICIPADO';

    wrap.appendChild(btn);

    /* Insert right after the header — most reliable anchor point */
    var header = form.querySelector('._rsi-modal-header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(wrap, header.nextSibling);
    } else {
      /* Fallback: before first offer card container */
      var offersHook = form.querySelector('#rsi-cod-form-quantity-offers-hook');
      if (offersHook && offersHook.parentNode) {
        offersHook.parentNode.insertBefore(wrap, offersHook);
      } else {
        form.insertBefore(wrap, form.firstChild);
      }
    }
  }

  /* ── 8. Trust bar (bottom of form) ── */
  function addTrustBar(form) {
    if (form.querySelector('.lco-trust-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'lco-trust-bar';
    TRUST.forEach(function (text) {
      var item = document.createElement('span');
      item.className = 'lco-trust-item';
      item.textContent = text;
      bar.appendChild(item);
    });
    form.appendChild(bar);
  }

  /* ── 9. Step headers (2 + 3) ── */
  function insertStepHeaders(form) {
    insertStepHeader(form, '2', 'TUS DATOS DE ENTREGA', function (f) {
      return f.querySelector('._rsi-modal-fields-item');
    });
    insertStepHeader(form, '3', 'CONFIRMA TU COMPRA', function (f) {
      return f.querySelector('#rsi-cod-form-tick-ups-hook') ||
             f.querySelector('._rsi-build-block-submit-button');
    });
  }

  function insertStepHeader(form, num, label, findTarget) {
    var target = findTarget(form);
    if (!target) return;
    var prev = target.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('lco-step-header')) return;

    var divider = document.createElement('div');
    divider.className = 'lco-step-divider';

    var header = document.createElement('div');
    header.className = 'lco-step-header';

    var numEl = document.createElement('div');
    numEl.className = 'lco-step-num';
    numEl.textContent = num;

    var labelEl = document.createElement('div');
    labelEl.className = 'lco-step-label';
    labelEl.textContent = label;

    header.appendChild(numEl);
    header.appendChild(labelEl);

    target.parentNode.insertBefore(divider, target);
    target.parentNode.insertBefore(header, divider);
  }

  /* ═══════════════════════════════════════════
     CONVERSION ANIMATIONS — injected elements
     ═══════════════════════════════════════════ */

  var PROOFS = [
    '✅ Ana (Bogotá) acaba de ordenar',
    '⭐ Carlos — "Llegó en 5 días, excelente"',
    '✅ Laura (Cali) completó su compra',
    '🔥 Diego (Barranquilla) — "Lo recomiendo 100%"',
    '✅ Valentina (Bucaramanga) ordenó hace 2 min',
    '⭐ Sofía — "Calidad increíble, volvería a comprar"',
    '✅ Andrés (Manizales) acaba de ordenar',
    '🔥 Natalia (Medellín) — "Superó mis expectativas"',
  ];

  var STOCK = [
    { pct: 72, text: '⚡ Solo quedan 3 unidades a este precio' },
    { pct: 46, text: '🔥 ¡Stock casi agotado!' },
    { pct: 28, text: '🚨 ¡Última oportunidad al mejor precio!' },
  ];

  /* ── Urgency bar ── */
  function addUrgencyBar(form) {
    if (form.querySelector('.lco-urgency-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'lco-urgency-bar';
    bar.innerHTML =
      '<span class="lco-urgency-dot"></span>' +
      '⚡ OFERTA ESPECIAL — PRECIOS EXCLUSIVOS HOY' +
      '<span class="lco-urgency-dot"></span>';
    var header = form.querySelector('._rsi-modal-header');
    if (header) header.parentNode.insertBefore(bar, header.nextSibling);
  }

  /* ── Countdown timer ── */
  function addTimer(form) {
    if (form.querySelector('.lco-timer-wrap')) return;
    var total = Math.floor(Math.random() * 330) + 510; /* 8:30 – 14:00 */
    var wrap = document.createElement('div');
    wrap.className = 'lco-timer-wrap';
    wrap.innerHTML =
      '<span class="lco-timer-label">⏰ Oferta expira en:</span>' +
      '<div class="lco-timer-digits">' +
        '<span class="lco-timer-block" id="lco-tm-m">--</span>' +
        '<span class="lco-timer-sep">:</span>' +
        '<span class="lco-timer-block" id="lco-tm-s">--</span>' +
      '</div>';
    var anchor = form.querySelector('.lco-urgency-bar') || form.querySelector('._rsi-modal-header');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (total <= 0) return;
      total--;
      var mEl = form.querySelector('#lco-tm-m');
      var sEl = form.querySelector('#lco-tm-s');
      if (!mEl || !sEl) return;
      var m = Math.floor(total / 60), s = total % 60;
      if (mEl.textContent !== pad(m)) { mEl.textContent = pad(m); mEl.classList.add('lco-flip'); setTimeout(function(){mEl.classList.remove('lco-flip');}, 350); }
      if (sEl.textContent !== pad(s)) { sEl.textContent = pad(s); sEl.classList.add('lco-flip'); setTimeout(function(){sEl.classList.remove('lco-flip');}, 350); }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Social proof ticker ── */
  function addTicker(form) {
    if (form.querySelector('.lco-ticker-wrap')) return;
    var doubled = PROOFS.concat(PROOFS).join('  ·  ');
    var wrap = document.createElement('div');
    wrap.className = 'lco-ticker-wrap';
    wrap.innerHTML = '<div class="lco-ticker-inner"><span class="lco-ticker-item">' + doubled + '</span></div>';
    var anchor = form.querySelector('.lco-timer-wrap') || form.querySelector('.lco-urgency-bar') || form.querySelector('._rsi-modal-header');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  /* ── Live viewers counter ── */
  function addLiveViewers(form) {
    if (form.querySelector('.lco-live-wrap')) return;
    var count = Math.floor(Math.random() * 28) + 18;
    var wrap = document.createElement('div');
    wrap.className = 'lco-live-wrap';
    wrap.innerHTML =
      '<span class="lco-live-dot"></span>' +
      '<span class="lco-live-text">👀 <span class="lco-live-count" id="lco-lc">' + count + '</span> personas están viendo esto ahora</span>';
    var anchor = form.querySelector('.lco-ticker-wrap') || form.querySelector('.lco-timer-wrap') || form.querySelector('.lco-urgency-bar');
    if (anchor) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    setInterval(function () {
      var el = form.querySelector('#lco-lc');
      if (!el) return;
      var delta = Math.random() > 0.5 ? 1 : -1;
      count = Math.max(12, Math.min(58, count + delta));
      el.classList.remove('lco-flip');
      void el.offsetWidth;
      el.classList.add('lco-flip');
      el.textContent = count;
      setTimeout(function () { el.classList.remove('lco-flip'); }, 380);
    }, 4200);
  }

  /* ── Stock indicators inside offer cards ── */
  function addStockIndicators(form) {
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card, i) {
      if (card.querySelector('.lco-stock-wrap')) return;
      var level = STOCK[i] || STOCK[STOCK.length - 1];
      var sw = document.createElement('div');
      sw.className = 'lco-stock-wrap';
      sw.innerHTML =
        '<div class="lco-stock-label">' + level.text + '</div>' +
        '<div class="lco-stock-bar"><div class="lco-stock-fill" style="width:0"></div></div>';
      var offer = card.querySelector('._rsi-quantity-offers-offer');
      if (offer) offer.parentNode.insertBefore(sw, offer.nextSibling);

      /* Animate fill after paint */
      requestAnimationFrame(function () {
        var fill = sw.querySelector('.lco-stock-fill');
        if (fill) fill.style.width = level.pct + '%';
      });
    });
  }

  /* ── Selection checkmark on product image ── */
  function setupCheckmarks(form) {
    function update() {
      form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
        var imgWrap = card.querySelector('._rsi-quantity-offers-offer ._rsi-modal-line-item-image-container');
        if (!imgWrap) return;
        imgWrap.style.position = 'relative';
        var existing = imgWrap.querySelector('.lco-offer-check');
        if (card.classList.contains('_rsi-quantity-offers-selected')) {
          if (!existing) {
            var ck = document.createElement('div');
            ck.className = 'lco-offer-check';
            ck.textContent = '✓';
            imgWrap.appendChild(ck);
          }
        } else {
          if (existing) existing.remove();
        }
      });
    }
    update();
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
      new MutationObserver(update).observe(card, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ── Bouncing arrow above submit button ── */
  function addCtaArrow(form) {
    if (form.querySelector('.lco-cta-arrow')) return;
    var submitBlock = form.querySelector('._rsi-build-block-submit-button');
    if (!submitBlock) return;
    var arrow = document.createElement('div');
    arrow.className = 'lco-cta-arrow';
    arrow.textContent = '↓';
    submitBlock.parentNode.insertBefore(arrow, submitBlock);
  }

  /* ── Periodic CTA shake ── */
  function setupCtaShake(form) {
    var btn = form.querySelector('._rsi-modal-submit-button');
    if (!btn) return;
    setInterval(function () {
      btn.classList.add('lco-cta-shaking');
      btn.addEventListener('animationend', function h() {
        btn.classList.remove('lco-cta-shaking');
        btn.removeEventListener('animationend', h);
      });
    }, 5500);
  }

  /* ── Main enhancement entry point ── */
  function enhance(form) {
    /* First pass: styles + structure */
    setTimeout(function () {
      styleHeader(form);
      styleStepTexts(form);
      styleOfferPrices(form);
      styleOfferCardsMobile(form);
      setupOfferCardsMobileObserver(form);
      styleSubmitBtn(form);
      stylePayAdvanceBtn(form);

      /* Conversion animations — top zone */
      addUrgencyBar(form);
      addTimer(form);
      addTicker(form);
      addLiveViewers(form);

      /* Early pay button above offers */
      insertPayAdvanceTop(form);

      /* Offer card enhancements */
      addBadges(form);
      addStockIndicators(form);
      setupCheckmarks(form);

      /* Form zone */
      insertStepHeaders(form);
      addCtaArrow(form);
      setupCtaShake(form);

      /* Footer */
      addTrustBar(form);
    }, 120);

    /* Second pass at 680ms — safety retry */
    setTimeout(function () {
      stylePayAdvanceBtn(form);
      styleOfferCardsMobile(form);
      insertPayAdvanceTop(form);
      addBadges(form);
      addStockIndicators(form);
      setupCheckmarks(form);
      addCtaArrow(form);
    }, 680);
  }

  /* ── MutationObserver — detects RSI modal injection ── */
  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : [];

  function wasSeen(el) {
    return typeof WeakSet !== 'undefined' ? seen.has(el) : seen.indexOf(el) !== -1;
  }
  function markSeen(el) {
    if (typeof WeakSet !== 'undefined') seen.add(el);
    else seen.push(el);
  }

  function checkNode(node) {
    if (!node || node.nodeType !== 1) return;
    var form = node.classList && node.classList.contains('_rsi-modal-form')
      ? node
      : node.querySelector && node.querySelector('._rsi-modal-form');
    if (form && !wasSeen(form)) { markSeen(form); enhance(form); }
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { m.addedNodes.forEach(checkNode); });
  }).observe(document.body, { childList: true, subtree: true });

  /* In case modal is already in the DOM */
  var existing = document.querySelector('._rsi-modal-form');
  if (existing && !wasSeen(existing)) { markSeen(existing); enhance(existing); }

})();
